import { deburr, isEqual, orderBy } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';

import countries from './countries';

type CountryItem = NonNullable<ReturnType<typeof countries>>[number];

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

const EMPTY_ARRAY: never[] = [];

const transformCountry = (country: CountryItem) => ({
  name: country.name_english,
  countryCode: country.country_code,
  defaultDistanceUnit: country.default_distance_unit,
  languageDefault: country.language_default,
  enabled: country.enabled,
  carbonCreditServicesEnabled: country.carbon_credit_services_enabled,
  currency: {
    b2cPayment: country.currency.b2cPayment,
    b2cDisplay: country.currency.b2cDisplay,
    cmpSuggestion: country.currency.cmpSuggest,
    cmpFiltered: country.currency.cmpFiltered,
  },
});

const orderedCountriesSelector = createDeepEqualSelector(countries, (items = null) =>
  items ? orderBy(items.map(transformCountry), [(item) => deburr(item.name)], ['asc']) : EMPTY_ARRAY,
);

const countriesDropdownSelector = createDeepEqualSelector(orderedCountriesSelector, (items) =>
  items.length === 0
    ? EMPTY_ARRAY
    : items.map((item) => ({
        key: item.countryCode,
        value: item.name,
        enabled: item.enabled,
        carbonCreditServicesEnabled: item.carbonCreditServicesEnabled,
        currency: item.currency,
        langDefault: item.languageDefault,
      })),
);

export default countriesDropdownSelector;
